import type { CSSProperties } from "react";
import { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import timeZones from "~config/timeZones";
import type { LabelValue } from "~types/labelValue.ts";
import CustomSelect from "../CustomSelect";

type Props = {
  allowClear?: boolean;
  className?: string;
  disabled?: boolean;
  placeholder?: string;
  style?: CSSProperties;
  value?: LabelValue | LabelValue[] | string;
  onChange?: (value: LabelValue | LabelValue[] | undefined) => void;
};

const SelectTimezone = ({ allowClear = true, className, disabled, onChange, placeholder, style, value }: Props) => {
  const options = useMemo(() => timeZones.map((timezone) => ({ value: timezone, label: timezone })), []);

  return (
    <CustomSelect
      style={{ width: "100%", minWidth: "unset", ...style }}
      value={value}
      showSearch
      optionFilterProp="label"
      onChange={(_, option) => {
        onChange?.(option as { value: string; label: string });
      }}
      options={options}
      placeholder={placeholder || <FormattedMessage id="timezone" />}
      allowClear={allowClear}
      className={className}
      disabled={disabled}
    />
  );
};

export default SelectTimezone;
